import { apiFetch } from './fetch';

export type UserPushDeviceDto = {
  id: string;
  platform: string;
  deviceName?: string | null;
  tokenPreview: string;
  updatedAt: string;
};

export type UserPushDevicesResponse = {
  fcmConfigured: boolean;
  devices: UserPushDeviceDto[];
};

export type PushSelfTestResult = {
  sent: boolean;
  attempted: number;
  succeeded: number;
  failed: number;
  errors: string[];
};

export type PushPreferences = {
  enabled: boolean;
  hasRegisteredDevice: boolean;
};

export async function fetchPushDevices(): Promise<UserPushDevicesResponse> {
  const res = await apiFetch('/api/push/devices');
  if (!res.ok) throw new Error('push devices failed');
  return res.json();
}

export async function sendPushSelfTest(): Promise<PushSelfTestResult> {
  const res = await apiFetch('/api/push/test', { method: 'POST' });
  if (res.status === 429) throw new Error('rate_limit');
  if (!res.ok) throw new Error('push test failed');
  return res.json();
}

export async function fetchPushPreferences(): Promise<PushPreferences> {
  const res = await apiFetch('/api/push/preferences');
  if (!res.ok) throw new Error('push preferences failed');
  return res.json();
}

export async function updatePushPreferences(enabled: boolean): Promise<void> {
  const res = await apiFetch('/api/push/preferences', {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ enabled }),
  });
  if (!res.ok) throw new Error('push preferences update failed');
}
